<template>
  <div class="flex input__field">
    <select v-model="dateValues.day">
      <option value="" disabled>{{ $t("datepicker.day") }}</option>
      <option v-for="i in 31" :key="`dobDay-${i}`" :value="i">{{ i }}</option>
    </select>

    <select v-model="dateValues.month">
      <option value="" disabled>{{ $t("datepicker.month") }}</option>
      <option v-for="i in 12" :key="`dobMonth-${i}`" :value="i">{{
        getMonthName(i)
      }}</option>
    </select>

    <select v-model="dateValues.year">
      <option value="" disabled>{{ $t("datepicker.year") }}</option>
      <option
        v-for="i in GetAvailableYears"
        :key="`dobMonth-${i}`"
        :value="i"
        >{{ i }}</option
      >
    </select>
  </div>
</template>

<script>
import DateTimeHelper from "@/mixins/DateTimeHelper";
import { mapGetters } from 'vuex'

export default {
  name: "DatePicker",
  mixins: [DateTimeHelper],
  props: {
    fieldLabel: String,
    currentDate: String,
    isBirthday: Boolean
  },
  data: function() {
    return {
      dateValues: {
        day: null,
        month: null,
        year: null
      }
    };
  },
  watch: {
    dateValues: {
      deep: true,
      handler() {
        this.$emit("changeDate", this.getDateFormat(this.getDate));
      }
    }
  },
  computed: {
    ...mapGetters([
      'reservation'
    ]),
    getDate() {
      if (
        this.dateValues.year &&
        this.dateValues.month &&
        this.dateValues.day
      ) {
        return new Date(
          this.dateValues.year,
          this.dateValues.month-1,
          this.dateValues.day
        );
      }
      return null;
    },
    GetAvailableYears() {
      var minimumRentalAge = this.reservation.car.minimum_rental_age;
      if(minimumRentalAge == null) 
      {
        minimumRentalAge = 18;
      }
        

      const range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      return range(
        new Date().getFullYear() - minimumRentalAge,
        new Date().getFullYear() - 122,
        -1
      );
    }
  },
  mounted() {
    this.initializeDatePicker();
  },
  methods: {
    initializeDatePicker: function() {
      if (this.currentDate) {
        this.dateValues.day = this.getDay(this.currentDate);
        this.dateValues.month = this.getMonth(this.currentDate);
        this.dateValues.year = this.getYear(this.currentDate);
      }
    }
  }
};
</script>
